module.exports = __webpack_public_path__ + "static/media/Illus-Empty_1@3x.33998466.png";